<template>
	<div id="patientExamsPage" class="layout-row">
		<div class="container mt-sm-5">
			<div class="card m-sm-2 shadow-sm border-0">
				<div class="card-body">
					<h5 class="card-title d-flex flex-row align-items-center"><i class="material-icons">info</i> {{ $t('Informations') }} - {{this.$user.patient.clinic_name_app ? this.$user.patient.clinic_name_app : this.$user.patient.clinic_name}}</h5>

						<div class="d-flex flex-column flex-sm-row">
							<div class="">
								<div class="mb-3" v-if="this.$user.patient.clinic_phone">
									<div class="text-muted">{{ $t('PhoneNumber') }}</div>
									<div><a v-bind:href="`tel:${this.$user.patient.clinic_phone}`">{{this.$user.patient.clinic_phone}}</a></div>
									<div class="dropdown-divider d-block d-sm-none"></div>
								</div>

								<div class="mb-3" v-if="this.$user.patient.clinic_email">
									<div class="text-muted">{{ $t('Email') }}</div>
									<div><a v-bind:href="`mailto:${this.$user.patient.clinic_email}`">{{this.$user.patient.clinic_email}}</a></div>
									<div class="dropdown-divider d-block d-sm-none"></div>
								</div>

								<div class="mb-3" v-if="this.$user.patient.clinic_working_time">
									<div class="text-muted">{{ $t('OpeningHours') }}</div>
									<div>{{this.$user.patient.clinic_working_time}}</div>
									<div>{{this.$user.patient.clinic_working_time_compl}}</div>
									<div class="dropdown-divider d-block d-sm-none"></div>
								</div>

								<div class="mb-3" v-if="this.$user.patient.clinic_address_maps">
									<div class="text-muted">{{ $t('Address') }}</div>
									<div><a v-bind:href="`https://www.google.com/maps/search/${this.$user.patient.clinic_address_maps}`">{{this.$user.patient.clinic_address}}</a></div>
								</div>
							</div>
						</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "patientClinicContactPage"
};
</script>

<style lang="scss">
@import "../../assets/_vars";

a {
	color:#333;
}

.container {
	@media screen and (max-width: $mobile) {
		padding:0 !important;
		height:100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/patient/patientClinicContactPage.vue